"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchasesService = void 0;
const tslib_1 = require("tslib");
const base_public_service_1 = require("../base-public-service");
const purchases_queries_1 = require("./purchases.queries");
const purchase_type_1 = require("../../mappers/purchase-type");
const date_time_1 = require("../../utils/date-time");
const globalTypes_1 = require("../generated/globalTypes");
class PurchasesService extends base_public_service_1.BasePublicService {
    getPurchases(cursor) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.request(purchases_queries_1.GET_PURCHASES, {
                cursor,
            });
            let purchases = response.purchases.entities
                .filter(({ status }) => status === globalTypes_1.PurchaseStatus.ACTIVE ||
                status === globalTypes_1.PurchaseStatus.CANCELED)
                .map(({ id, type, expiresAt, metaSiteId, createdAt, price }) => ({
                id,
                type: purchase_type_1.purchaseTypeMapper.toVod(type),
                date: createdAt,
                dateTs: (0, date_time_1.dateToTs)(createdAt),
                expirationTs: expiresAt ? (0, date_time_1.dateToTs)(expiresAt) : null,
                metasiteId: metaSiteId,
                price,
            }));
            if (response.purchases.cursor) {
                purchases = [
                    ...purchases,
                    ...(yield this.getPurchases(response.purchases.cursor)),
                ];
            }
            return purchases;
        });
    }
}
exports.PurchasesService = PurchasesService;
//# sourceMappingURL=purchases.js.map